<div class="append-container" style="height: 30px" #container></div>
<form [formGroup]="formGroup" class="k-form k-form-horizontal" style="max-width: 700px; width: 700px">
  <fieldset class="k-form-fieldset">
    <!-- Artigo -->
    <kendo-formfield orientation="horizontal">
      <kendo-label class="k-label" [for]="" [text]="customMsgService.translate('artigo')">
      </kendo-label>
      <kendo-dropdownlist formControlName="refArtigo" textField="nome" valueField="id" [defaultItem]="placeHolder"
        [data]="listaDeArtigos" required>
      </kendo-dropdownlist>
      <kendo-formerror>
        {{ customMsgService.translate("error") }}:
        {{ customMsgService.translate("theField") }}
        {{ customMsgService.translate("artigo") }}
        {{ customMsgService.translate("isRequired") }}</kendo-formerror>
    </kendo-formfield>

    <!-- Quantidade desejada -->
    <kendo-formfield orientation="horizontal">
      <kendo-label class="k-label" [for]="" [text]="customMsgService.translate('quantidadeDesejada')">
      </kendo-label>
      <kendo-numerictextbox [min]="0" [step]="1" format="n0" [autoCorrect]="true" formControlName="quantidadeDesejada"
        required>
      </kendo-numerictextbox>
      <kendo-formerror>
        {{ customMsgService.translate("error") }}:
        {{ customMsgService.translate("theField") }}
        {{ customMsgService.translate("quantidadeDesejada") }}
        {{ customMsgService.translate("isRequired") }}</kendo-formerror>
    </kendo-formfield>

    <!-- Quantidade alerta -->
    <kendo-formfield orientation="horizontal">
      <kendo-label class="k-label" [for]="" [text]="customMsgService.translate('quantidadeAlertaDeStock')">
      </kendo-label>
      <kendo-numerictextbox [min]="0" [step]="1" format="n0" [autoCorrect]="true"
        formControlName="quantidadeAlertaStock" required>
      </kendo-numerictextbox>
      <kendo-formerror>
        {{ customMsgService.translate("error") }}:
        {{ customMsgService.translate("theField") }}
        {{ customMsgService.translate("quantidadeAlertaDeStock") }}
        {{ customMsgService.translate("isRequired") }}</kendo-formerror>
    </kendo-formfield>

    <!-- Botões -->
    <div class="k-form-buttons">
      <button kendoButton (click)="cancelChanges()">
        {{ customMsgService.translate('cancel') }}
      </button>
      <button kendoButton [primary]="true" (click)="saveChanges()">
        {{ customMsgService.translate('saveChanges') }}
      </button>
    </div>
  </fieldset>
</form>